function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "downloadIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 981",
  transform: "translate(7390 256)",
  fill: "#fff",
  stroke: "#707070",
  d: "M0 0h16v16H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-7390 -256)",
  clipPath: "url(#downloadIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7391.943 272a1.952 1.952 0 01-1.943-1.96v-2.54a.5.5 0 111 0v2.543a.953.953 0 00.943.957h12.111a.956.956 0 00.946-.96v-2.54a.5.5 0 111 0v2.54a1.952 1.952 0 01-1.942 1.96zm5.884-3.038a.5.5 0 01-.167-.11l-3.493-3.493a.5.5 0 01.707-.707l2.626 2.625V256.5a.5.5 0 111 0v10.807l2.622-2.642a.5.5 0 01.707.707l-3.46 3.482a.5.5 0 01-.542.109z"
}));

function SvgDownloadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
}

export default SvgDownloadIcon;